import React, { Component } from 'react';

class Home extends Component {
	render() {
		return <h1 className='container text-center'>Home</h1>;
	}
}

export default Home;
